import { render, staticRenderFns } from "./TransactionOrdersWidget.vue?vue&type=template&id=f7469704&scoped=true"
import script from "./TransactionOrdersWidget.vue?vue&type=script&lang=js"
export * from "./TransactionOrdersWidget.vue?vue&type=script&lang=js"
import style0 from "./TransactionOrdersWidget.vue?vue&type=style&index=0&id=f7469704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7469704",
  null
  
)

export default component.exports